import script from "./ResumeGuideModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeGuideModal.vue?vue&type=script&setup=true&lang=js"

import "./ResumeGuideModal.vue?vue&type=style&index=0&id=5f970210&lang=less"

const __exports__ = script;

export default __exports__